import $axios from "../../api";
import FileSaver from "file-saver";

const PREFIX_1 = "tiktok/dash/1";
const PREFIX_2 = "tiktok/dash/2";
const PREFIX_3 = "tiktok/dash/3";

// Guard urutan request (last-request-wins): dua klik preset beruntun = dua
// request paralel; tanpa guard, response yang tiba TERAKHIR yang tampil —
// belum tentu filter yang terakhir dipilih. Pola sama dengan
// stores/main/Dashboard.js (map per action) supaya konsisten di-grep.
const reqSeq = {};
const nextSeq = (key) => (reqSeq[key] = (reqSeq[key] || 0) + 1);
const isCurrent = (key, seq) => reqSeq[key] === seq;

// URLSearchParams menserialisasi undefined jadi string "undefined" —
// buang entri kosong supaya backend tidak menerima tanggal literal itu.
const cleanParams = (params) =>
  Object.fromEntries(
    Object.entries(params || {}).filter(
      ([, v]) => v !== undefined && v !== null && v !== ""
    )
  );

const state = () => ({
  isLoading: false,
  isLoadingDetail: false,
  isLoadingTable: false,
  isSuccess: false,
  errors: "",
  page: 1,
  pageDetail: 1,
  // ========== Tier 1 ========== //
  dashboardData: [],
  // ======== End Tier 1 ======== //

  // ========== Tier 2 ========== //
  // Performance Product
  performRateData: [],
  performVisitData: [],
  performCartData: [],
  performOrdersData: [],
  // Tren Penjualan
  topCategoryData: [],
  topCategoryOverview: [],
  topBrandData: [],
  topBrandOverview: [],
  // Aktivitas Pembelian
  topMemberData: [],
  topMemberOverview: [],
  InActiveMemberData: [],
  InActiveMemberOverview: [],
  // Promosi 
  topVoucherData: [],
  topVoucherOverview: [],
  // Metode Pembayaran
  topPaymentData: [],
  topPaymentOverview: [],
  // Metode Pembayaran
  outOffStockData: [],
  almostOutStockData: [],
  // Manajemen Member
  managementMemberData: [],
  // ======== End Tier 2 ======== //

  // ========== Tier 3 ========== //
  // Performance Product Detail
  performVisitDetail: [],
  performCartDetail: [],
  performOrderDetail: [],
  // Tren Penjualan Detail
  topCategoryDetail: [],
  topBrandDetail: [],
  // Promosi & Payment Detail
  topVoucherDetail: [],
  topPaymentDetail: [],
  memberDetail: [],
  // ======== End Tier 3 ======== //

});

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_LOADING_DETAIL(state, payload) {
    state.isLoadingDetail = payload;
  },
  SET_LOADING_TABLE(state, payload) {
    state.isLoadingTable = payload;
  },
  SET_IS_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_PAGE_DETAIL(state, payload) {
    state.pageDetail = payload;
  },
  SET_DASHBOARD_DATA(state, payload) {
    state.dashboardData = payload;
  },
  SET_PERFORMRATE_DATA(state, payload) {
    state.performRateData = payload;
  },
  SET_PERFORMVISIT_DATA(state, payload) {
    state.performVisitData = payload;
  },
  SET_PERFORMCART_DATA(state, payload) {
    state.performCartData = payload;
  },
  SET_PERFORMORDERS_DATA(state, payload) {
    state.performOrdersData = payload;
  },
  SET_TOPCATEGORY_DATA(state, payload) {
    state.topCategoryData = payload;
  },
  SET_TOPCATEGORY_OVERVIEW(state, payload) {
    state.topCategoryOverview = payload;
  },
  SET_TOPBRAND_DATA(state, payload) {
    state.topBrandData = payload;
  },
  SET_TOPBRAND_OVERVIEW(state, payload) {
    state.topBrandOverview = payload;
  },
  SET_TOPMEMBER_DATA(state, payload) {
    state.topMemberData = payload;
  },
  SET_TOPMEMBER_OVERVIEW(state, payload) {
    state.topMemberOverview = payload;
  },
  SET_INACTIVEMEMBER_DATA(state, payload) {
    state.InActiveMemberData = payload;
  },
  SET_INACTIVEMEMBER_OVERVIEW(state, payload) {
    state.InActiveMemberOverview = payload;
  },
  SET_TOPVOUCHER_DATA(state, payload) {
    state.topVoucherData = payload;
  },
  SET_TOPVOUCHER_OVERVIEW(state, payload) {
    state.topVoucherOverview = payload;
  },
  SET_TOPPAYMENT_DATA(state, payload) {
    state.topPaymentData = payload;
  },
  SET_TOPPAYMENT_OVERVIEW(state, payload) {
    state.topPaymentOverview = payload;
  },
  SET_OUTOFFSTOCK_DATA(state, payload) {
    state.outOffStockData = payload;
  },
  SET_ALMOSTOUTSTOCK_DATA(state, payload) {
    state.almostOutStockData = payload;
  },
  SET_MANAGEMENTMEMBER_DATA(state, payload) {
    state.managementMemberData = payload;
  },
  SET_PERFORMVISIT_DETAIL(state, payload) {
    state.performVisitDetail = payload;
  },
  SET_PERFORMCART_DETAIL(state, payload) {
    state.performCartDetail = payload;
  },
  SET_PERFORMORDER_DETAIL(state, payload) {
    state.performOrderDetail = payload;
  },
  SET_TOPCATEGORY_DETAIL(state, payload) {
    state.topCategoryDetail = payload;
  },
  SET_TOPBRAND_DETAIL(state, payload) {
    state.topBrandDetail = payload;
  },
  SET_TOPVOUCHER_DETAIL(state, payload) {
    state.topVoucherDetail = payload;
  },
  SET_TOPPAYMENT_DETAIL(state, payload) {
    state.topPaymentDetail = payload;
  },
  SET_MEMBER_DETAIL(state, payload) {
    state.memberDetail = payload;
  },
};

const actions = {
  // Tier 1
  getDashboardData({ commit, state, rootState, dispatch }, payload) {
    const seq = nextSeq('dash1');
    commit("SET_LOADING", true);

    const params = cleanParams(payload && payload.payload ? payload.payload : payload);
    const queryString = Object.keys(params).length ? `?${new URLSearchParams(params).toString()}` : "";

    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX_1}${queryString}`)
        .then((res) => {
          if (!isCurrent('dash1', seq)) return; // response basi dari filter lama — drop
          commit("SET_DASHBOARD_DATA", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          // Error dari request basi juga di-drop — request baru sudah/akan
          // menampilkan data & error-nya sendiri; toast telat cuma membingungkan.
          if (!isCurrent('dash1', seq)) return;
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  // Tier 2
  getPerformanceData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${PREFIX_2}/product?page=${state.page}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_PERFORMORDERS_DATA", res.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },
  exportProduct({ commit, state, rootState, dispatch }, payload) {
    const queryString = payload
      ? payload.startsWith("&")
        ? `?${payload.slice(1)}`
        : payload
      : "";
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX_2}/export/product${queryString}`, {
          responseType: "blob",
        })
        .then((res) => {
          const fileName = `performanceProduct_view=${rootState.Main.view}${queryString || ""}_${new Date().toISOString().slice(0, 19).replace(/[:-]/g, "")}.xlsx`;
          FileSaver.saveAs(res.data, fileName);
          resolve(res);
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },
  exportMember({ commit, state, rootState, dispatch }, payload) {
    const queryString = payload
      ? payload.startsWith("&")
        ? `?${payload.slice(1)}`
        : payload
      : "";
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX_2}/export/customers-perform${queryString}`, {
          responseType: "blob",
        })
        .then((res) => {
          const fileName = `performanceMember_view=${rootState.Main.view}${queryString || ""}_${new Date().toISOString().slice(0, 19).replace(/[:-]/g, "")}.xlsx`;
          FileSaver.saveAs(res.data, fileName);
          resolve(res);
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },
  exportInactiveMember({ commit, state, rootState, dispatch }, payload) {
    const queryString = payload
      ? payload.startsWith("&")
        ? `?${payload.slice(1)}`
        : payload
      : "";
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX_2}/export/customers-notperform${queryString}`, {
          responseType: "blob",
        })
        .then((res) => {
          const fileName = `performanceInactiveMember_view=${rootState.Main.view}${queryString || ""}_${new Date().toISOString().slice(0, 19).replace(/[:-]/g, "")}.xlsx`;
          FileSaver.saveAs(res.data, fileName);
          resolve(res);
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },
  exportPayment({ commit, state, rootState, dispatch }, payload) {
    const queryString = payload
      ? payload.startsWith("&")
        ? `?${payload.slice(1)}`
        : payload
      : "";
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX_2}/export/payment${queryString}`, {
          responseType: "blob",
        })
        .then((res) => {
          const fileName = `performancePayment_view=${rootState.Main.view}${queryString || ""}_${new Date().toISOString().slice(0, 19).replace(/[:-]/g, "")}.xlsx`;
          FileSaver.saveAs(res.data, fileName);
          resolve(res);
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },
  exportPromotions({ commit, state, rootState, dispatch }, payload) {
    const queryString = payload
      ? payload.startsWith("&")
        ? `?${payload.slice(1)}`
        : payload
      : "";
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX_2}/export/promotions${queryString}`, {
          responseType: "blob",
        })
        .then((res) => {
          const fileName = `tiktok_promotions_view=${rootState.Main.view}${queryString || ""}_${new Date().toISOString().slice(0, 19).replace(/[:-]/g, "")}.xlsx`;
          FileSaver.saveAs(res.data, fileName);
          resolve(res);
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },
  exportBrand({ commit, state, rootState, dispatch }, payload) {
    const queryString = payload
      ? payload.startsWith("&")
        ? `?${payload.slice(1)}`
        : payload
      : "";
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX_2}/export/brand${queryString}`, {
          responseType: "blob",
        })
        .then((res) => {
          const fileName = `tiktok_brand_view=${rootState.Main.view}${queryString || ""}_${new Date().toISOString().slice(0, 19).replace(/[:-]/g, "")}.xlsx`;
          FileSaver.saveAs(res.data, fileName);
          resolve(res);
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },
  exportCategory({ commit, state, rootState, dispatch }, payload) {
    const queryString = payload
      ? payload.startsWith("&")
        ? `?${payload.slice(1)}`
        : payload
      : "";
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX_2}/export/category${queryString}`, {
          responseType: "blob",
        })
        .then((res) => {
          const fileName = `tiktok_category_view=${rootState.Main.view}${queryString || ""}_${new Date().toISOString().slice(0, 19).replace(/[:-]/g, "")}.xlsx`;
          FileSaver.saveAs(res.data, fileName);
          resolve(res);
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },
  getTopCategoryData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${PREFIX_2}/category?page=${state.page}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_TOPCATEGORY_DATA", res.data.data);
          commit("SET_TOPCATEGORY_OVERVIEW", res.data.top_product);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getTopBrandData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${PREFIX_2}/brand?page=${state.page}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_TOPBRAND_DATA", res.data.data);
          commit("SET_TOPBRAND_OVERVIEW", res.data.top_product);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getTopMemberData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${PREFIX_2}/customers-perform?page=${state.page}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_TOPMEMBER_DATA", res.data.data);
          commit("SET_TOPMEMBER_OVERVIEW", {
            countmember: res.data.countmember,
            countnonmember: res.data.countnonmember,
            totalmember: res.data.totalmember,
            gmv: res.data.gmv,
          });
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getInactiveMemberData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${PREFIX_2}/customers-notperform?page=${state.page}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_INACTIVEMEMBER_DATA", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getTopVoucherData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${PREFIX_2}/promotions?page=${state.page}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_TOPVOUCHER_DATA", res.data.data);
          commit("SET_TOPVOUCHER_OVERVIEW", {
            count_order: res.data.count_order,
            count_member: res.data.count_member,
            count_transaction: res.data.count_transaction,
          });
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getTopPaymentData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${PREFIX_2}/payment?page=${state.page}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_TOPPAYMENT_DATA", res.data.data);

          // Clone sebelum sort — `.sort()` in-place pada res.data.data.data akan
          // mutate state.topPaymentData.data (shared reference) → override sort backend.
          const overview = [...(res.data.data.data || [])].sort(
            (a, b) => b.total_order - a.total_order
          );
          commit("SET_TOPPAYMENT_OVERVIEW", overview);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  // Tier 3
  getPerformanceOrderDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_DETAIL", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${PREFIX_3}/product?page=${state.pageDetail}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_PERFORMORDER_DETAIL", res.data);
          commit("SET_LOADING_DETAIL", false);
        })
        .catch((error) => {
          commit("SET_LOADING_DETAIL", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getTopCategoryDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_DETAIL", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${PREFIX_3}/category?page=${state.pageDetail}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_TOPCATEGORY_DETAIL", res.data);
          commit("SET_LOADING_DETAIL", false);
        })
        .catch((error) => {
          commit("SET_LOADING_DETAIL", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getTopBrandDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_DETAIL", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${PREFIX_3}/brand?page=${state.pageDetail}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_TOPBRAND_DETAIL", res.data);
          commit("SET_LOADING_DETAIL", false);
        })
        .catch((error) => {
          commit("SET_LOADING_DETAIL", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getTopVoucherDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_DETAIL", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${PREFIX_3}/promotions?page=${state.pageDetail}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_TOPVOUCHER_DETAIL", res.data);
          commit("SET_LOADING_DETAIL", false);
        })
        .catch((error) => {
          commit("SET_LOADING_DETAIL", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getTopPaymentDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_DETAIL", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${PREFIX_3}/payment?page=${state.pageDetail}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_TOPPAYMENT_DETAIL", res.data);
          commit("SET_LOADING_DETAIL", false);
        })
        .catch((error) => {
          commit("SET_LOADING_DETAIL", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getMemberDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `tiktok/member/view?page=${state.pageDetail}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_MEMBER_DETAIL", res.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
